import { type ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export type FloatingActionPortalProps = {
    children: ReactNode
}

/**
 * Renders `position: fixed` content into `document.body` so ancestor
 * transforms / overflow cannot clip or mis-position floating controls.
 * Cloned from @sentinel-legal/forms FloatingActionPortal.
 */
export const FloatingActionPortal = ({ children }: FloatingActionPortalProps) => {
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])

    if (!mounted) return null
    return createPortal(children, document.body)
}
